import { render, staticRenderFns } from "./ViewCouponView.vue?vue&type=template&id=65697a8f"
import script from "./ViewCouponView.vue?vue&type=script&lang=js"
export * from "./ViewCouponView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports